export default {
    activeProjectId: null,
    workingClip: null,
    focusedTranscodingClip: null,
    isClipSaveDialogOpen: false,
    isClipUploadDialogOpen: false,
    isRecording: false,
    isEditingClipTitleOrDescription: false,
    isPanoramaMode: false,
    panoramicClipData: null,
    isUploadingPanoramicClip: false,
    isInfoModalOpen: false,
    playingClipId: null,
    focusedLegacyVideoId: null,
    clips: [],
    videos: [],
    uploads: [],
    failedUploads: [],
    projects: [],
    transcodingJobs: [],
    isLoading: true,
    hasLoadedTranscodingJobs: false,
    processingStack: [],
    isPaused: true,
    isSaving: false,
    isUnsaved: false,
    isClipUpdating: false,
    isLibraryExpanded: false,

    isPublishing: false,
    publishingErrors: {},
    isPublishDialogOpen: false,
    playbackRate: 1,
}